import React, { Component } from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import './tips.sass'

export default class Tips extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tipCtx: props.ctx //ctx,type
        }
    }

    render() {
        const { tipCtx } = this.state
        return (
            <p className={tipCtx['type'] + ' tips'}>
                {tipCtx['ctx']}
            </p>
        )
    }
}